import { render } from "./EnConstruccion.vue?vue&type=template&id=cffc667a"
import script from "./EnConstruccion.vue?vue&type=script&lang=js"
export * from "./EnConstruccion.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/AxumWebPage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__